var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSecondary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6E736E",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.91 10.605c.677 0 1.226-.565 1.226-1.263S16.587 8.08 15.91 8.08s-1.227.565-1.227 1.263.55 1.263 1.227 1.263zm1.226 11.827V14.2c0-.619-.55-1.12-1.227-1.12-.678 0-1.227.501-1.227 1.12v8.233c0 .62.55 1.12 1.227 1.12.678 0 1.227-.5 1.227-1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm0 3c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3z"
  }))));
}
export default SvgInfoSecondary;